/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { fieldPackageStatus, fieldType } from '@/constants.js';
import { useTrigger } from '@/utils/comHook.js';
import ModalML from '@/components/modal_ml/ModalML';
import EditModal from '@/containers/edit_modal/EditModal';
import { useDispatch, useSelector } from 'dva';
import { message } from 'antd';
import { isInt } from '@/utils/validation';

const baseInfo = {
  variableType: 'TEMPORARY',
};
const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const trigger = useTrigger();
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['tvf/editField'];
  const [intType, setIntType] = useState('');
  const { fetchData } = props;
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    dispatch({
      type: 'tvf/setSearchValue',
      payload: {
        values,
      },
    });
  };

  const onReset = () => {
    form.resetFields();
    // handleSearch({});
  };
  const editSingleField = (value) => {
    console.log('value', value);
    dispatch({
      type: 'tvf/addField',
      payload: {
        values: {
          ...value,
          ...baseInfo,
        },
      },
      callback: (d) => {
        console.log('d', d);
        if (d?.code) {
          message.error(d.message);
        } else {
          message.success('新增成功');
        }
        fetchData();
        trigger.close();
      },
    });
  };

  const onChange = (e) => {
    setIntType(e);
  };

  const formList = [
    {
      name: 'fieldName',
      type: 'input',
      label: '临时变量名称',
      required: true,
    },
    {
      name: 'variableName',
      type: 'input',
      label: '变量名',
      required: true,
    },
    {
      name: 'fieldType',
      type: 'select',
      label: '字段类型',
      required: true,
      option: toOption(fieldType),
      onChange: onChange,
    },
    {
      name: 'defaultValue',
      type: 'input',
      label: '默认值',
      // required: true,
      // intType: intType,
      requiredRule: [
        {
          required: true,
          whitespace: true,
          message: '请输入默认值',
        },
        intType === 'INTEGER'
          ? ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || isInt(value)) {
                  return Promise.resolve();
                }
                return Promise.reject('默认值格式为正整数');
              },
            })
          : {},
      ],
    },
    {
      name: 'exceptionValue',
      type: 'input',
      label: '异常值',
      required: true,
    },
    {
      name: 'description',
      type: 'input',
      label: '字段描述',
      required: true,
    },
    // {
    //   name: 'fieldStatus',
    //   type: 'select',
    //   label: '状态',
    //   required: true,
    //   option: toOption(fieldPackageStatus),
    // },
  ];
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      <div className={styles.input_contain}>
        {/* 临时变量名称 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="临时变量名称"
          placeVal="请输入临时变量名称"
          name="fieldName"
          allowClear={true}
          // icon={}
        />
        {/* 变量名 */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="变量名"
          placeVal="请输入变量名"
          name="variableName"
          allowClear={true}
          // icon={}
        />

        {/* 字段状态 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="200px"
          labelVal="字段状态"
          placeVal="请选择字段状态"
          name="fieldStatus"
          allowClear={true}
          option={toOption(fieldPackageStatus)}
          // icon={}
        />
      </div>
      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML size="large" value="重置" fontsize="16px" onClick={onReset} />
        <ButtonML
          size="large"
          value="新增"
          fontsize="16px"
          onClick={trigger.open}
        />
      </div>
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
        // visible={true}
      >
        <EditModal
          handleCancel={trigger.close}
          formList={formList}
          loading={loading}
          edit={editSingleField}
          setIntType={setIntType}
        />
      </ModalML>
    </Form>
  );
};

export default SearchGroup;
